import { render, staticRenderFns } from "./EmployeeFaceFormEdit.vue?vue&type=template&id=e4fb7d3c"
import script from "./EmployeeFaceFormEdit.vue?vue&type=script&lang=js"
export * from "./EmployeeFaceFormEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports